import { Card, CardContent } from '../ui/card';

export const TripDetailsCards = ({ tripInput, status }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-6 max-w-3xl" data-testid="trip-details-cards">
    <Card className="bg-white/90 backdrop-blur-xl border-white/30 hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5">
      <CardContent className="p-3">
        <p className="text-[10px] text-ocean/70 uppercase tracking-wide font-semibold">Budget</p>
        <p className="font-semibold text-ocean capitalize text-sm">{tripInput.budget}</p>
      </CardContent>
    </Card>
    <Card className="bg-white/90 backdrop-blur-xl border-white/30 hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5">
      <CardContent className="p-3">
        <p className="text-[10px] text-sky/70 uppercase tracking-wide font-semibold">Style</p>
        <p className="font-semibold text-sky-dark text-sm">
          {tripInput.travel_styles?.slice(0, 2).join(', ')}
        </p>
      </CardContent>
    </Card>
    <Card className="bg-white/90 backdrop-blur-xl border-white/30 hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5">
      <CardContent className="p-3">
        <p className="text-[10px] text-ocean/70 uppercase tracking-wide font-semibold">Interests</p>
        <p className="font-semibold text-ocean text-sm">
          {tripInput.interests?.slice(0, 2).join(', ')}
        </p>
      </CardContent>
    </Card>
    <Card className="bg-white/90 backdrop-blur-xl border-white/30 hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5">
      <CardContent className="p-3">
        <p className={`text-[10px] uppercase tracking-wide font-semibold ${status === 'completed' ? 'text-green-600/70' : 'text-gold/70'}`}>Status</p>
        <p className={`font-semibold text-sm ${status === 'completed' ? 'text-green-600' : 'text-gold'}`}>
          {status === 'completed' ? '\u2713 Ready' : '\u231b Pending'}
        </p>
      </CardContent>
    </Card>
  </div>
);
